import { FC } from 'react'
import styled from 'styled-components'

import fullLogo from './bluesite-hub-black.png'

const Image = styled.img`
  width: 100%;
  max-width: 174px;
  height: auto;
  display: block;
`

const LogoFullBluesite: FC = () => <Image src={fullLogo} alt="Bluesite HR Hub" />

export default LogoFullBluesite
